const socket = new WebSocket('ws://kmpdata.ddns.net:8080');
const entradas = {
    Topico: '',
    Value: ''
};
// Abre la conexión
socket.addEventListener('open', function (event) {
    document.getElementById("Alerta").innerHTML = "Conectado a Servidor!!";
})
// Al cerrar
socket.addEventListener('close', function (event) {
    document.getElementById("Alerta").innerHTML = "Servidor Cerrado!!";
});

// Escucha por mensajes
socket.addEventListener('message', function (event) {
    var isTrueSet;
    console.log(event.data);
    document.getElementById("Alerta").innerHTML = event.data;
    var msgr = JSON.parse(event.data);
    console.log(msgr.topico);
    switch (msgr.topico) {
        case "kmpdata/1":
            isTrueSet = (msgr.value === 'true');
                document.getElementById(msgr.topico).checked = isTrueSet;
            break;
        case "kmpdata/2":
            isTrueSet = (msgr.value === 'true');
                document.getElementById(msgr.topico).checked = isTrueSet;
            break;
        default:
            break;

    }

});

export function GuardarVar(e) {
    e.preventDefault();
    entradas[e.target.name] = e.target.value;
    console.log(entradas);
};

export function Enviar_Mensaje() {

    socket.send(JSON.stringify(entradas));
};

export function CambiaTopico(e) {
    const temp = {
        Topico: '',
        Value: ''
    };
    temp.Topico = e.target.id;
    temp.Value = e.target.checked.toString();
    socket.send(JSON.stringify(temp));
}

export function Hola(e) {
    //e.preventDefault();
    console.log(e.target);
}